import {Page} from './Page.js';
import {Form} from './Form.js';

class PageReservation extends Page
{
	constructor ()
	{
		console.log('PageReservation');
		super();

		this.$formSearch = $('#frm_search');
		this.$formDocuments = $('#frm_documents');

		new Form( this.$formSearch, false );
		new Form( this.$formDocuments, false, this.submit.bind(this) );

		this.$btnSearch = this.$formSearch.find('button.btn_action');
		this.$btnAddField = this.$formDocuments.find('button.add_field');
		this.$btnSend = this.$formDocuments.find('button.btn_action');

		this.strInputTemplate = $('#tpl_field').html();
		console.log(this.$btnSend );

		this.bindEvents();
	}

	bindEvents ()
	{
		this.$btnSearch.on('click', this.search.bind(this));
		this.$btnAddField.on('click', this.addField.bind(this));
		this.$btnSend.on('click', this.setCurrentType.bind(this));
        
        this.$formDocuments.on("click", "button[data-action='remove-email']", this.removeEmail.bind(this));
	}

	removeEmail (_e)
    {
        let $btn = $(_e.currentTarget);
        
        let $field = $btn.parents(".field");
        
        $field.remove();
    }
    
	search ( _e )
	{
		_e.preventDefault();

		console.log("search", this.$btnSearch.val());
		
		/*
		$.ajax();
		*/
		
		if ($("#txt_search").val() != "")
        {
            this.$formDocuments.slideDown();
        }
        else
		{
            this.addError($("#txt_search"),$("#txt_search").attr("data-error-message") );
            
            $("#txt_search").one("focus", this.clearError.bind(this,$("#txt_search") ));
		}
	}

	addField ( _e )
	{
		_e.preventDefault();
		
		let $this = $(_e.target);
		let $parent = $this.parents( 'div.field_group' );
		let iFieldCount = $parent.data('fieldCount');

		if ( !iFieldCount )
		{
			iFieldCount = 1;
		}

		iFieldCount++;
		$parent.data('fieldCount', iFieldCount);

		let strInput = this.strInputTemplate.replace('{{LABEL}}', $parent.attr('data-label'));
		strInput = strInput.replace(/{{FIELD_ID}}/g, $parent.attr('data-id-prefix') + iFieldCount );

		$( strInput ).insertBefore( $this );
		return false;
	}
    
    
    displayError (_index, _data)
    {
        if (_data.success != 0)
            return;
        
        let $field = $("#" + _data.field);
        
        this.addError($field, _data.message );
        
    }
	
	onSubmit (_strType, _data)
	{
        if (_data.success == 1)
        {
        	let strMessageSuccess = $("#msg_success_" + _strType).attr("data-message-success");
        	
            $("#msg_success_" + _strType).text(strMessageSuccess);
            
            return;
        }
        
        if (_strType == "invoice")
		{
            let strMessageError = $("#msg_error_" + _strType).attr("data-message-error");
            
            $("#msg_error_" + _strType).text(strMessageError);
            $("#msg_success_" + _strType).text("");
            
            console.log("#error" + _strType, strMessageError);
            
			return;
		}
		
        let arrState = _data.state;
        
        $.each(arrState, this.displayError.bind(this));
        
        let $firstError = $("p.error").first().parent("fieldset");
        let $header = $("header");
        
        let iScrollTo = $firstError.offset().top - $header.height() - 20;
        
        $('html, body').animate({
            scrollTop: iScrollTo
        }, 250);
	}
	
	setCurrentType (_e)
	{
		
		let btn = $(_e.target);
		
		let strType = btn.attr("data-type");
		
		$("#lastType").val(strType);
	}
	
	
	submit (_e)
	{
		_e.preventDefault();
        
        let strType = $("#lastType").val();
        
        console.log("submit ", strType);
        
        if (strType == "INVOICE")
		{
			this.submitInvoice();
		}
		else
		{
			this.submitDocument(strType);
		}
		

	}
	
	submitDocument (_strType)
	{
        let strCode = this.$formSearch.find("#txt_search").val();
        let strLang = this.$formDocuments.find("#lang").val();
        let strURL = `/${strLang}/ajax/send-document`;
        
        this.$formDocuments.find("#code").val(strCode);
		
        console.log("strURL", strURL);
        console.log("strLang", strLang);
        
        $.ajax(
            {
                url:strURL,
                data: this.$formDocuments.serialize(),
                dataType:"JSON",
                method:"POST"
            }
        )
            .done (this.onSubmit.bind(this, "doc"));
	}
    
    submitInvoice ()
    {
        let strCode = this.$formSearch.find("#txt_search").val();
        let strLang = this.$formDocuments.find("#lang").val();
        let strURL = `/${strLang}/ajax/send-invoice`;
    
        this.$formDocuments.find("#code").val(strCode);
    
        console.log("strURL", strURL);
        console.log("strLang", strLang);
    
        $.ajax(
            {
                url:strURL,
                data: this.$formDocuments.serialize(),
                dataType:"JSON",
                method:"POST"
            }
        )
            .done (this.onSubmit.bind(this, "invoice"));
    }
    
    
    addError ( _$el, _strMsg )
    {
        this.clearError(_$el);
        let $fieldset = _$el.parents('fieldset');
        
        $fieldset.append('<p class="error">' + _strMsg + '</p>');
        $fieldset.addClass('has-error');
    }
    
    clearError ( _$el )
    {
        console.log('clearError');
        let $fieldset = _$el.parents('fieldset');
        $fieldset.addClass('has-content');
        $fieldset.removeClass('has-error');
        $fieldset.find('.error').remove();
        
    }
}

export {PageReservation};